import { render, staticRenderFns } from "./kurumsalriskraporu.vue?vue&type=template&id=45c177a9"
import script from "./kurumsalriskraporu.vue?vue&type=script&lang=js"
export * from "./kurumsalriskraporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports